import { POST, SUCCESS } from "../utils/const/http-const";
// import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";

export async function verifyLogin(usuario, password) {
  try {
    let data = { error: true };
    const { code, body, message, idTypeWebUser } = await fetch(
      `${BASE_URL}/autenticacion/login-web`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: POST,
        body: JSON.stringify({ usuario, password }),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.token = body;
      data.idTypeWebUser = idTypeWebUser;
    } else {
      data.error = true;
      data.message = message;
      data.token = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("verifyLogin err");
    console.log(err);
    return { error: true, message: err };
  }
}